import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { ObjectLibraryWidget } from './ObjectLibraryWidget';
import { objectTool } from './ObjectTool';

export const objectLibraryToolboxItem = ToolboxItem({
    id: 'objectLibrary',
    label: 'Insert...',
    ui: ObjectLibraryWidget,
    placement: 'right',
    weight: 5010,
    tools: [objectTool]
});
